<template>
    <v-card flat>
        <v-card-title>
            <h4 class="subheading text-xs-left font-weight-regular section-title--color">
                Sentiment
            </h4>
        </v-card-title>
        <v-list class="py-0 pb-2" style="max-height: 200px;" v-if="sentimentPageReady && summaryReady">
            <v-list-tile v-for="(category, index) in facebookSummary.fbcomments.category_range" :key="index">
                <v-list-tile-action style="min-width: 32px; margin-right: -5px;">
                    <v-checkbox
                            :disabled="!monitorActionReady"
                            hide-details
                            class="custom-checkbox-size"
                            v-model="selectedCategory"
                            :ripple="false"
                            color="bindezcolor"
                            :value="category.value"
                            @change="filterBySentiment"
                    ></v-checkbox>
                </v-list-tile-action>
                <v-list-tile-content>
                    <v-list-tile-title class="body-1">{{category.value | textUppercase}}</v-list-tile-title>
                </v-list-tile-content>
                <v-tooltip top>
                    <template slot="activator" slot-scope="{on}">
                        <v-chip v-on="on" color="bindezcolor" small label text-color="#fff">{{category.count | abbrNumber}}</v-chip>
                    </template>
                    <span>{{category.count | formatNumber}}</span>
                </v-tooltip>
            </v-list-tile>
        </v-list>
        <div v-else class="d-flex fill-height align-center" style="height: 200px">
            <v-progress-circular indeterminate color="bindezcolor"/>
        </div>
    </v-card>
</template>

<script>
	import {mapState, mapMutations} from 'vuex'

	export default {
		name: "SentimentFilter",
		computed: {
			...mapState([
				'facebookSummary',
                'monitorActionReady'
			]),

			...mapState('mention', [
				'summaryReady'
			]),

			...mapState('sentiment', [
				'sentimentPageReady',
				'selectedSentiment'
			]),

			selectedCategory: {
				get() {
					return this.selectedSentiment
				},
				set(value) {
					this.setSelectedSentiment(value)
				}
			},
		},

		methods: {
			...mapMutations('sentiment', [
				'setSelectedSentiment',
                'setSelectedFolder'
			]),

            filterBySentiment(){
				this.$ua.trackEvent("Filter Comments", "check", "Filter Comments By Sentiment");
				this.setSelectedFolder(undefined);
				this.$emit('filterBySentiment')
            }
		},

		filters: {
			textUppercase(raw) {
				return raw.charAt(0).toUpperCase() + raw.substr(1)
			},
		}
	}
</script>

<style scoped>

</style>
